import { APIProvider, type APIProviderProps } from '@vis.gl/react-google-maps';
import React from 'react';
import PlaceAutocompleteRender, {
  type PlaceAutocompleteRenderProps,
} from './PlaceAutocompleteRender';

export interface PlaceAutocompleteProps
  extends PlaceAutocompleteRenderProps,
    Omit<APIProviderProps, 'apiKey'> {
  apiKey?: string;
}

const PlaceAutocomplete = React.forwardRef<HTMLInputElement, PlaceAutocompleteProps>(
  function PlaceAutoComplete(
    {
      apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '',
      options,
      onSelect,
      children,
      ...props
    },
    ref,
  ) {
    return (
      <APIProvider apiKey={apiKey} {...props}>
        <PlaceAutocompleteRender ref={ref} onSelect={onSelect} options={options}>
          {children}
        </PlaceAutocompleteRender>
      </APIProvider>
    );
  },
);

export default PlaceAutocomplete;
